import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AppLogo from "../components/AppLogo";
import MenuButtons from "../components/MenuButtons"

const getColors = (t) => [
  { name: t("colors.eloksal"), code: "#9E9D9D" },
  { name: t("colors.bronz"), code: "#B7A27A" },
  { name: t("colors.ahsap"), code: "#765c48" },
  { name: t("colors.antrasit"), code: "#353C40" },
  { name: t("colors.beyaz"), code: "#E3E1E1" },
  { name: t("colors.siyah"), code: "#000000" },
];

const getGlassColors = (t) => [
  { name: t("glass.seffaf"), code: "#A5F1F6" },
  { name: t("glass.fume"), code: "#5C5D5E" },
  { name: t("glass.bronz"), code: "#CA935E" },
  { name: t("glass.mavi"), code: "#49A0E4" },
  { name: t("glass.yesil"), code: "#64BAA0" },
];

function addUniqueColorToStart(array, colorCode, name = "Özel") {
  if (!colorCode || array.some((c) => c.code.toLowerCase() == colorCode.toLowerCase())) {
    return array;
  }
  return [{ name, code: colorCode }, ...array];
}

export default function LeftPanel({
  aluminumColor,
  setAluminumColor,
  glassColor,
  setGlassColor,
  glassColor2,
  setGlassColor2,
  isDouble,
  isOpen,
  handleToggle,
  controlsRef,
  rendererRef,
  sceneRef,
  cameraRef,
  isMobile,
  isEditMode,
  params,
  config
}) {
  const { t } = useTranslation();
  const [showColors, setShowColors] = useState(true);

  const aluminumColors = addUniqueColorToStart(getColors(t), config?.almColor, config.almColorName);
  let tempGlassColors = addUniqueColorToStart(getGlassColors(t), config?.glassColor, config.glassColorName);
  if (isDouble) {
    tempGlassColors = addUniqueColorToStart(tempGlassColors, config?.glassColor2, config.glassColor2Name);
  }

  const ColorSelector = ({ title, list, selected, setSelected, iconSize = 30, fontSize = 12 }) => (
    <>
      {title && <h4 style={{  fontSize: fontSize + 1 }}>{title}</h4>}
      <div
        style={{
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
          paddingBottom: 0,
          paddingLeft: isMobile ? 5 : 0,
          paddingTop: isMobile ? 0 : 0
        }}
      >
        {list.map((color) => {
          const isActive = selected === color.code;
          return (
            <div
              key={color.name}
              style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
            >
              <div
                onClick={() => setSelected(color.code)}
                style={{
                  width: iconSize,
                  height: iconSize,
                  borderRadius: "50%",
                  background: color.code,
                  cursor: "pointer",
                  transition: "transform 0.2s ease-in-out",
                  flexShrink: 0,
                  opacity: 0.6,
                  transform: isActive ? "scale(1.2)" : "scale(1)"
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.transform = "scale(1)";
                }}
              />
              {isActive && (
                <div style={{ marginTop: 2, fontSize, fontWeight: 500 }}>{color.name}</div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );

  const expandableStyle = {
    overflow: "hidden",
    transition: "max-height 0.4s ease, opacity 0.4s ease",
    maxHeight: showColors ? 1000 : 0,
    opacity: showColors ? 1 : 0,
  };

  if (isMobile) {
    return (
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          background: "#ffffffee",
          borderTop: "1px solid #ccc",
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 10,
          zIndex: 10,
          boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <button
          onClick={() => setShowColors((prev) => !prev)}
          style={{
            width: "80%",
            backgroundColor: "#ffffff",
            border: "none",
            borderRadius: "10px",
            padding: "10px",
            margin: "8px auto", // ✔️ Ortalar
            fontSize: 13,
            fontWeight: 600,
            color: "#333",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            transition: "background 0.2s ease-in-out",
            display: "block",
          }}
        >
          {showColors ? t("hideColor") : t("showColor")}
        </button>

        <div style={expandableStyle}>
          <h3 style={{ fontSize: 12, marginTop: 0, marginBottom: 5 }}>{t("almColor")}</h3>
          <ColorSelector
            title=""
            list={aluminumColors}
            selected={aluminumColor}
            setSelected={setAluminumColor}
            iconSize={32}
            fontSize={11}
          />
          <h3 style={{ fontSize: 12, marginTop: 5, marginBottom: 5 }}>{t("glassColor")}</h3>
          <ColorSelector
            title=""
            list={tempGlassColors}
            selected={glassColor}
            setSelected={setGlassColor}
            iconSize={32}
            fontSize={11}
          />
          {isDouble && (
            <>
              <h3 style={{ fontSize: 12, marginTop: 5, marginBottom: 5 }}>{t("glassColor2")}</h3>
              <ColorSelector
                title=""
                list={tempGlassColors}
                selected={glassColor2}
                setSelected={setGlassColor2}
                iconSize={32}
                fontSize={11}
              />
            </>
          )}
        </div>

        <MenuButtons
          setAluminumColor={setAluminumColor}
          setGlassColor={setGlassColor}
          setGlassColor2={setGlassColor2}
          isOpen={isOpen}
          handleToggle={handleToggle}
          controlsRef={controlsRef}
          rendererRef={rendererRef}
          sceneRef={sceneRef}
          cameraRef={cameraRef}
          isMobile={isMobile}
          isEditMode={isEditMode}
          params={params}
          config={config}
        />
      </div>
    );
  }

  // MASAÜSTÜ PANEL
  return (
    <div
      style={{
        width: "250px",
        background: "#fff",
        paddingLeft: "8px",
        paddingRight: "8px",
        boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <h3>Alüminyum Rengi</h3>
      <ColorSelector list={aluminumColors} selected={aluminumColor} setSelected={setAluminumColor} />

      <h3 style={{ marginTop: 10 }}>Cam Rengi</h3>
      <ColorSelector list={tempGlassColors} selected={glassColor} setSelected={setGlassColor} />

      {isDouble && (
        <>
          <h3 style={{ marginTop: 10 }}>2. Cam Rengi</h3>
          <ColorSelector list={tempGlassColors} selected={glassColor2} setSelected={setGlassColor2} />
        </>
      )}

      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 12 }}>
        <MenuButtons
          setAluminumColor={setAluminumColor}
          setGlassColor={setGlassColor}
          setGlassColor2={setGlassColor2}
          isOpen={isOpen}
          handleToggle={handleToggle}
          controlsRef={controlsRef}
          rendererRef={rendererRef}
          sceneRef={sceneRef}
          cameraRef={cameraRef}
          isMobile={isMobile}
          isEditMode={isEditMode}
          params={params}
          config={config}
        />
        <AppLogo isMobile={isMobile} />
      </div>
    </div>
  );
}
